<template>
  <v-container>
    <h1 class="text-center">BILLS</h1>
    <v-container>
      <v-row class="text-center">
        <v-col>
          <p class="overline">TOTAL BILLS {{ BILLS.length }}</p>
        </v-col>
        <v-col>
          <v-btn icon @click="getBills">
            <v-icon>mdi-sync</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <br />
      <v-data-table
        :headers="headers"
        :items="BILLS"
        :search="search"
        :items-per-page="15"
        class="elevation-1"
      >
        <template v-slot:item.timestamp="{ item }">
          <p>{{item.timestamp | DateAndTime}}</p>
        </template>
        <template v-slot:item.uniq_id="{ item }">
          <v-btn icon @click="getBillData(item)">
            <v-icon color="primary1" dark>mdi-printer-check</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "BILL NO",
          align: "start",
          value: "id",
          sortable: true,
        },
        {
          text: "CUSTOMER NAME",
          align: "start",
          value: "name",
          sortable: true,
        },
        {
          text: "PH",
          align: "start",
          value: "phone",
          sortable: false,
        },
        {
          text: "TOTAL ₹",
          align: "start",
          value: "grandtotal",
          sortable: false,
        },
        {
          text: "BILLED ON",
          align: "center",
          value: "timestamp",
          sortable: true,
        },
        {
          text: "PRINT",
          align: "center",
          value: "uniq_id",
          sortable: false,
          width: "5%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["BILLS"]),
  },
  methods: {
    ...mapActions(["GET_ALLBILLS"]),
    getBills() {
      this.$store.commit("SET_LOADING", true);
      this.GET_ALLBILLS().then(() => {
        this.$store.commit("SET_LOADING", false);
      });
    },
    getBillData(item) {
      // console.log(item);
      let routeData = this.$router.resolve({
        name: "PRINTBILL",
        params: { id: item.id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
